import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';

const formatAsOf = (d: Date): string => {
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  const hours = d.getHours();
  const mins = String(d.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12;
  return `${dd}/${mm}/${yyyy}, ${hours12}:${mins} ${ampm}`;
};

interface FooterProps {
  /** Optional override for the "as of" timestamp. Defaults to render time. */
  asOfDate?: Date;
}

/**
 * Footer disclaimer mirroring the agent SUPER Picker app's footer
 * (`SuperPickerApp.tsx` lines ~25516-25544).
 */
export const Footer: React.FC<FooterProps> = ({ asOfDate }) => {
  const asOfStr = useMemo(() => formatAsOf(asOfDate ?? new Date()), [asOfDate]);
  const disclaimer = `Disclaimer: SUPER Picker is intended solely as a research and analytical support tool to assist agents in evaluating project information.
Information and materials as of ${asOfStr}. Subject to change without prior notice. Users are advised to verify all information and confirm the latest selling price with the respective Project IC.`;

  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        pt: 3,
        borderTop: '1px solid',
        borderColor: 'divider',
        textAlign: 'center',
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: 'rgba(var(--color-text-rgb), 0.5)',
          fontStyle: 'italic',
          display: 'block',
          mb: 1,
          px: 2,
          lineHeight: 1.6,
          whiteSpace: 'pre-line',
        }}
      >
        {disclaimer}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Powered by Huttons Projects &amp; Transformation Office
      </Typography>
    </Box>
  );
};

export default Footer;
